import { render, staticRenderFns } from "./CatalogStockStatus.vue?vue&type=template&id=15d36eb3&"
import script from "./CatalogStockStatus.vue?vue&type=script&lang=js&"
export * from "./CatalogStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports